import { generateTotalAngle } from '../../spinningWheel/angle';
import { prepareSpinningWheelDOM, showHighlight } from '../../spinningWheel/prepareDOM';
import { setupSpinningWheel } from '../../spinningWheel/setup';
import soundExecutor from './soundExecutor';

const spinningWheelSounds = {
	intro: 'spinning_wheel_intro',
	outro: 'spinning_wheel_outro',
	spin: 'spinning_wheel',
};

const pauseAfterPaintBeforeStart = 4000;

export default function spinningWheelExecutor({ prizes, winner, title: wheelTitle, winnerAngle }, done) {
	log(`Notifications.soSpinner "${winner}"`);

	const {
		notification, 
		canvases
	} = prepareSpinningWheelDOM(wheelTitle);
	
	Screen.elements.notifications.append(notification);

	const onFinish = () => {
		notification.remove();
		done?.();
	};

	const { mainCanvas } = canvases;
	const soundDismissFunctions = [];

	const playSound = (sound) => {
		const soundUrl = Screen.sounds.filter(soundUrl => soundUrl.indexOf(`${sound}.`) >= 0)[0];

		soundDismissFunctions.push(
			soundExecutor({
				sound: soundUrl
			}, () => {})
		);
	};

	const highlight = (text) => {
		const highlightedTextNode = showHighlight(text);
		$(mainCanvas).css('z-index', -1); 
		notification.append(highlightedTextNode);
		return highlightedTextNode;
	};

	const onShowWinner = () => {
		playSound(spinningWheelSounds.outro);

		const winnerIndex = prizes.map((s) => s.id).indexOf(winner);
		highlight(prizes[winnerIndex].name);
	};

	const { run, dismiss } = setupSpinningWheel(canvases, prizes, onFinish, onShowWinner);

	const titleHighlight = highlight(wheelTitle || Screen.trans('Spin the wheel!'));

	const totalAngle = generateTotalAngle(winner, winnerAngle, prizes);

	playSound(spinningWheelSounds.intro);

	const spinTimeout = setTimeout(
		() => {
			titleHighlight.remove();
			$(mainCanvas).css('z-index', '');
			playSound(spinningWheelSounds.spin);
			run(totalAngle);
		},
		pauseAfterPaintBeforeStart
	);

	return () => {
		clearTimeout(spinTimeout);
		for (const soundDismiss of soundDismissFunctions) {
			soundDismiss?.();
		}
		dismiss();
		onFinish();
	};
}
